<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Übersicht · Ökosystem</p>

      <h2 class="presentation-page__title">Drei Partner — eine durchgängige Lösung</h2>

      <p class="presentation-page__text">
        Sie sprechen mit einem Partner. Im Hintergrund arbeiten alle drei zusammen.
      </p>

      <div class="presentation-page__group-cards">
        <article
          v-for="partner in partners"
          :key="partner.title"
          class="presentation-page__group-card"
        >
          <div
            :class="[
              'presentation-page__group-card-header',
              `presentation-page__group-card-header--${partner.accent}`,
            ]"
          >
            {{ partner.header }}
          </div>

          <div class="presentation-page__group-card-body">
            <h3 class="presentation-page__group-card-title">{{ partner.title }}</h3>

            <div class="presentation-page__group-card-accent" aria-hidden="true"></div>

            <p class="presentation-page__group-card-text">{{ partner.text }}</p>
          </div>
        </article>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage08',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      partners: [
        {
          header: 'EPC & O&M',
          accent: 'brand-teal',
          title: 'e way Energy',
          text:
            'Plant, baut und betreibt PV-Anlagen schlüsselfertig — als Teil der Salvia Gebäudetechnik und der börsennotierten Eiffage-Gruppe.',
        },
        {
          header: 'Projektentwickler',
          accent: 'brand-primary',
          title: 'Solveen',
          text:
            'Sichert Dach- und Grundstücksrechte, strukturiert die Investition, übernimmt Genehmigung und Finanzierung.',
        },
        {
          header: 'CRM & Plattform',
          accent: 'brand-teal',
          title: 'RETIS',
          text:
            'Die digitale Schicht: Lead-Management, Dokumentenaustausch, Projektstatus, automatisierte Abrechnung.',
        },
      ],
    };
  },
};
</script>
